import {PageSubContainerSkeleton} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function OfferTemplatePreviewPending() {
  return (
    <PageSubContainerSkeleton>
      <Skeleton className="h-full min-h-75 rounded-xl" />
    </PageSubContainerSkeleton>
  );
}
